import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import enums from '../enum';
import componentServices from '../componentServices';

import SalesJobs from './salesJobs';
import BuilderLeadTimes from './builderLeadTimes';
import ContractorList from './contractorList';
import SalesPerformance from './salesPerformance';
import VendorList from './vendorList';
import { getModel, ModelCollection } from 'Scripts/store';

const BuilderJobsHeading = () => {
	const { store } = componentServices;
	const routeState = store.getIn(['viewState', 'routeState']);
	const currentEmployee = componentServices.securityContext.getCurrentEmployee();
	const targetEmployee = routeState && routeState.employeeKey ? getModel({ store, collection: ModelCollection.employees, key: routeState.employeeKey}) : currentEmployee;

	return currentEmployee && targetEmployee && currentEmployee.key !== targetEmployee.key ? <h1>Salesperson • <span>{ targetEmployee.fullName }</span></h1> : <div className="logo" />;
};

class BuilderHeader extends React.Component<any,any> {
	handleRouteClick (key, e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.replacePathSegmentAt(1, key, true), {});
	}

	render () {
		const items = [];
		const buttons = [{
			path: 'performance',
			name: 'Performance',
			test: () => componentServices.securityContext.currentUserHasFeature('builder-sales', 'manage-sales-performance')
		}, {
			path: 'jobs',
			name: 'Jobs'
		}, {
			path: 'lead-times',
			name: 'Lead Times'
		}, {
			path: 'contractors',
			name: 'Builders',
			test: () => componentServices.securityContext.currentUserHasFeature('builder-sales', 'contractor-basic')
		}, {
			path: 'suppliers',
			name: 'Suppliers'
		}];

		_.forEach(_.filter(buttons, b => !b.test || b.test()), button => {
			let className = 'button';

			// TODO: deal with possible disabled status of header links
			className += (componentServices.router.isActive('builder-sales', button.path)) ? ' on' : '';

			items.push(<li key={button.path}><a onClick={this.handleRouteClick.bind(this, button.path)} className={className}><span>{button.name}</span></a></li>);
		});

		return (
			<header>
				<ul className="menu">
					{ items }
				</ul>
			</header>
		);
	}
}

class BuilderModule extends React.Component<any,any> {
	componentDidMount () {
		actions.setHeader({
			key: 'builderModuleHeader',
			element: (
				<BuilderHeader key={'builderModuleHeader'} />
			)
		});
	}

	componentWillUnmount () {
		actions.deleteHeader({ key: 'builderModuleHeader' });
	}

	render () {
		const { children } = this.props;

		return children;
	}
}

componentServices.router.addRoutes([{
	path: '/builder-sales/performance',
	component: ({ ...props }) => <BuilderModule { ...props}><SalesPerformance businessSegment={ enums.businessSegments.Builder } { ...props} /></BuilderModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'dashboard performance jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature('builder-sales', 'manage-sales-performance'))
}, {
	path: '/builder-sales/jobs',
	component: ({ ...props }) => <BuilderModule { ...props}><SalesJobs businessSegment={ enums.businessSegments.Builder } { ...props} /></BuilderModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'jobDetail',
	heading: <BuilderJobsHeading />,
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('builder-sales'))
}, {
	path: '/builder-sales/lead-times',
	component: ({ ...props }) => <BuilderModule { ...props}><BuilderLeadTimes { ...props} /></BuilderModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'jobDetail',
	heading: <BuilderJobsHeading />,
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('builder-sales'))
}, {
	path: '/builder-sales/contractors',
	contentClass: 'dashboard jobDetail',
	component: ({ ...props }) => {
		return <BuilderModule { ...props}><ContractorList types={[enums.contractorTypes.Developer]} moduleKey="builder-sales" /></BuilderModule>;
	},
	onEnter: componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature('builder-sales', 'contractor-basic'))
}, {
	path: '/builder-sales/suppliers',
	contentClass: 'dashboard jobDetail',
	component: ({ ...props }) => {
		return <BuilderModule { ...props}><VendorList types={[enums.vendorTypes.Cabinet_Supplier, enums.vendorTypes.Counter_Supplier, enums.vendorTypes.Outside_Supplier, enums.vendorTypes.Internal_Warehouse, enums.contractorTypes.Delivery_Company]} moduleKey="builder-sales" /></BuilderModule>;
	}
}, {
	path: '/builder-sales',
	onEnter: ({ replace }) => {
		replace('/builder-sales/jobs');

		// cancel the navigation
		return false;
	}
}]);

export default BuilderModule;